export const getIsSetupModeActive = (state) => {
  return state.setupMode != null && state.setupMode.endAt == null;
};

export const getSetupMode = (state) => {
  return state.setupMode;
};
